module.exports = __webpack_public_path__ + "static/media/whale.1992fad9.svg";